import cx from 'clsx';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import styles from './steps.module.css';

export interface StepsProps extends ComponentPropsWithoutRef<'ul'> {
  steps: string[];
  className?: string;
}

export function Steps({ steps, className, ...props }: StepsProps): ReactNode {
  return (
    <ul className={cx(className, styles.steps)} {...props}>
      {steps.map(step => (
        <li className={cx('body-standard', styles.step)} key={step}>
          {step}
        </li>
      ))}
    </ul>
  );
}
